import React from 'react';
import RedocComponent from './RedocComponent';

function App() {
    return <RedocComponent />;
}

export default App;
